(function ($) {
    $(document).ready(function () {
        const archive_slider_cfg = {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        };

        // Wait for Select2 to be initialized
        function waitForSelect2() {
            return new Promise((resolve) => {
                const checkSelect2 = () => {
                    const selects = document.querySelectorAll('.destination-select, .topic-select, .season-select');
                    const hasSelect2 = Array.from(selects).some(select =>
                        select.nextElementSibling && select.nextElementSibling.classList.contains('select2-container')
                    );

                    if (hasSelect2 || selects.length === 0) {
                        resolve();
                    } else {
                        setTimeout(checkSelect2, 100);
                    }
                };
                checkSelect2();
            });
        }

        // Function to update filters via AJAX
        function updateFiltersViaAjax(postType, template, destinationId = null, topicId = null, seasonId = null) {
            const section = document.querySelector(`[data-post-type="${postType}"]`);
            if (!section) return;

            const postsContainer = section.querySelector(`[data-archive-posts="${template}"]`);
            const paginationContainer = section.querySelector(`[data-archive-pagination="${template}"]`);
            const noPostsContainer = section.querySelector(`[data-archive-no-posts="${template}"]`);

            if (postsContainer) postsContainer.classList.add('loading');
            if (paginationContainer) paginationContainer.classList.add('loading');

            const ajaxData = {
                action: 'filter_archive_posts',
                template: template,
                post_type: postType,
                destination_id: destinationId || '',
                topic_id: topicId || '',
                season_id: seasonId || ''
            };

            $.ajax({
                url: ThemeJS.Variables.Ajax.url,
                type: 'POST',
                data: ajaxData,
                success: function (response) {
                    if (response.success) {
                        postsContainer?.classList.remove('loading');
                        paginationContainer?.classList.remove('loading');

                        if (template === 'behind-the-scenes' || template === 'behind-the-scenes-video' || template === 'behind-the-scenes-written') {
                            // Handle behind-the-scenes template with separate video and written sections
                            const hasVideoPosts = response.data.video_html?.trim() !== '';
                            const hasWrittenPosts = response.data.written_html?.trim() !== '';
                            const hasNoPosts = response.data.no_posts_html?.trim() !== '';

                            // Find all behind-the-scenes sections on the page
                            const allBehindTheScenesSections = document.querySelectorAll('[data-archive-section="behind-the-scenes"]');

                            allBehindTheScenesSections.forEach(behindTheScenesSection => {
                                // Update video section
                                const videoSection = behindTheScenesSection.querySelector('.archive-video-section');
                                if (videoSection) {
                                    if (hasVideoPosts) {
                                        videoSection.innerHTML = response.data.video_html;
                                        videoSection.style.display = 'block';
                                        // Reinitialize slider for video section
                                        const sliderElement = videoSection.querySelector('.archive-posts-slider');
                                        if (sliderElement) {
                                            const $sliderEle = $(sliderElement);
                                            if ($sliderEle.hasClass('slick-initialized')) {
                                                $sliderEle.slick('unslick');
                                            }
                                            $sliderEle.slick(archive_slider_cfg);
                                        }
                                    } else {
                                        // Show no-posts message instead of hiding the section
                                        videoSection.innerHTML = response.data.video_no_posts_html || '<div class="archive-no-posts" data-archive-no-posts="behind-the-scenes"><p>No posts found matching your criteria.</p></div>';
                                        videoSection.style.display = 'block';
                                    }
                                }

                                // Update written section
                                const writtenSection = behindTheScenesSection.querySelector('.archive-written-section');
                                if (writtenSection) {
                                    if (hasWrittenPosts) {
                                        writtenSection.innerHTML = response.data.written_html;
                                        writtenSection.style.display = 'block';
                                    } else {
                                        // Show no-posts message instead of hiding the section
                                        // writtenSection.innerHTML = response.data.written_no_posts_html || '<div class="archive-no-posts" data-archive-no-posts="behind-the-scenes"><p>No posts found matching your criteria.</p></div>';
                                        // writtenSection.style.display = 'block';
                                        writtenSection.style.display = 'none';
                                    }
                                }

                                // Update pagination for written posts
                                const writtenPaginationContainer = behindTheScenesSection.querySelector(`[data-archive-pagination="behind-the-scenes-written"]`);
                                if (writtenPaginationContainer) {
                                    if (hasWrittenPosts && response.data.pagination_html) {
                                        writtenPaginationContainer.innerHTML = response.data.pagination_html;
                                        writtenPaginationContainer.style.display = 'block';
                                    } else {
                                        writtenPaginationContainer.innerHTML = '';
                                        writtenPaginationContainer.style.display = 'none';
                                    }
                                }

                            });

                        } else {
                            // Handle other templates (default behavior)
                            const hasPosts = response.data.posts_html?.trim() !== '';
                            const hasNoPosts = response.data.no_posts_html?.trim() !== '';

                            if (postsContainer) {
                                postsContainer.innerHTML = hasPosts ? response.data.posts_html : '';
                                postsContainer.style.display = hasPosts ? 'block' : 'none';
                                if (postsContainer.classList.contains('has-slider')) {
                                    // Reinitialize slider if needed
                                    const sliderElement = postsContainer.querySelector('.archive-posts-slider');
                                    const $sliderEle = $(sliderElement);
                                    if ($sliderEle.hasClass('slick-initialized')) {
                                        $sliderEle.slick('unslick');
                                    }
                                    $sliderEle.slick(archive_slider_cfg);
                                }
                            }

                            if (paginationContainer) {
                                if (hasPosts && response.data.pagination_html) {
                                    paginationContainer.innerHTML = response.data.pagination_html;
                                    paginationContainer.style.display = 'block';
                                } else {
                                    paginationContainer.innerHTML = '';
                                    paginationContainer.style.display = 'none';
                                }
                            }

                            if (noPostsContainer) {
                                if (hasNoPosts) {
                                    noPostsContainer.innerHTML = response.data.no_posts_html;
                                    noPostsContainer.style.display = 'block';
                                } else {
                                    noPostsContainer.style.display = 'none';
                                }
                            }
                        }

                        updateURLWithoutReload(postType, destinationId, topicId, seasonId);
                    }
                },
                error: function () {
                    if (postsContainer) {
                        postsContainer.innerHTML = '<div class="error">Error loading posts. Please try again.</div>';
                    }
                }
            });
        }

        // Update URL
        function updateURLWithoutReload(postType, destinationId = null, topicId = null, seasonId = null) {
            const url = new URL(window.location);
            const paramsToRemove = [];

            for (const [key] of url.searchParams.entries()) {
                if (key.startsWith(postType + '_')) {
                    paramsToRemove.push(key);
                }
            }
            paramsToRemove.forEach(param => url.searchParams.delete(param));

            if (destinationId) url.searchParams.set(postType + '_destination', destinationId);
            if (topicId) url.searchParams.set(postType + '_topic', topicId);
            if (seasonId) url.searchParams.set(postType + '_season', seasonId);

            url.searchParams.delete(postType + '_paged');
            url.searchParams.delete('paged');

            window.history.pushState({}, '', url.toString());
        }

        // Load saved values from URL
        function setSelectedValuesFromURL() {
            const url = new URL(window.location);
            const destinationSelects = document.querySelectorAll('.destination-select');
            const topicSelects = document.querySelectorAll('.topic-select');
            const seasonSelects = document.querySelectorAll('.season-select');

            destinationSelects.forEach(select => {
                const postType = select.getAttribute('data-post-type');
                const param = url.searchParams.get(postType + '_destination');
                if (param) {
                    select.value = param;
                    $(select).trigger('change');
                }
            });

            topicSelects.forEach(select => {
                const postType = select.getAttribute('data-post-type');
                const param = url.searchParams.get(postType + '_topic');
                if (param) {
                    select.value = param;
                    $(select).trigger('change');
                }
            });

            seasonSelects.forEach(select => {
                const postType = select.getAttribute('data-post-type');
                const param = url.searchParams.get(postType + '_season');
                if (param) {
                    select.value = param;
                    $(select).trigger('change');
                }
            });
        }

        // Initialize when Select2 ready
        waitForSelect2().then(() => {
            const destinationSelects = document.querySelectorAll('.destination-select');
            const topicSelects = document.querySelectorAll('.topic-select');
            const seasonSelects = document.querySelectorAll('.season-select');

            // Destination
            destinationSelects.forEach(select => {
                $(select).on('select2:select select2:clear', function () {
                    const postType = this.dataset.postType;
                    const destinationId = this.value;
                    const topicSelect = document.querySelector(`.topic-select[data-post-type="${postType}"]`);
                    const seasonSelect = document.querySelector(`.season-select[data-post-type="${postType}"]`);
                    const topicId = topicSelect ? topicSelect.value : null;
                    const seasonId = seasonSelect ? seasonSelect.value : null;
                    const template = this.closest('form')?.dataset.filter || 'default';
                    updateFiltersViaAjax(postType, template, destinationId, topicId, seasonId);
                });
            });

            // Topic
            topicSelects.forEach(select => {
                $(select).on('select2:select select2:clear', function () {
                    const postType = this.dataset.postType;
                    const topicId = this.value;
                    const destinationSelect = document.querySelector(`.destination-select[data-post-type="${postType}"]`);
                    const seasonSelect = document.querySelector(`.season-select[data-post-type="${postType}"]`);
                    const destinationId = destinationSelect ? destinationSelect.value : null;
                    const seasonId = seasonSelect ? seasonSelect.value : null;
                    const template = this.closest('form')?.dataset.filter || 'default';
                    updateFiltersViaAjax(postType, template, destinationId, topicId, seasonId);
                });
            });

            // Season
            seasonSelects.forEach(select => {
                $(select).on('select2:select select2:clear', function () {
                    const postType = this.dataset.postType;
                    const seasonId = this.value;
                    const destinationSelect = document.querySelector(`.destination-select[data-post-type="${postType}"]`);
                    const topicSelect = document.querySelector(`.topic-select[data-post-type="${postType}"]`);
                    const destinationId = destinationSelect ? destinationSelect.value : null;
                    const topicId = topicSelect ? topicSelect.value : null;
                    const template = this.closest('form')?.dataset.filter || 'default';
                    updateFiltersViaAjax(postType, template, destinationId, topicId, seasonId);
                });
            });

            // Initialize from URL
            setSelectedValuesFromURL();
        });

        function initBtsSlider() {
            const $slider = $('.archive-posts-slider');

            if (!$slider.length) return;

            // If already initialized, destroy first
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            $slider.slick(archive_slider_cfg);
        }

        initBtsSlider();

    });
})(jQuery);